import React, { Component } from 'react';
import { NavLink } from "react-router-dom";
import ResetPasswordForm from '../Components/ResetPasswordForm.js';
import AuthenticationService from '../Services/AuthenticationService.js';
import UserService from '../Services/UserService.js';
import { withApi } from '../Providers/WebServiceProvider.js';
import { message } from '../messages.js';

import logo from '../assets/images/tovertaal_logo.png';

class ForgotPassword extends Component
{
	constructor(props) {
		super(props);

		this.resetPasswordSubmit = this.resetPasswordSubmit.bind(this);
		this.userService         = new UserService(props.webServiceContext.getApi());         
	}

	resetPasswordSubmit = (email) => {
		const that = this;

		return new Promise((resolve, reject) => {
			that.userService.resetPassword(email)
				.then(function () {
					resolve({ credentials: message('FORGOT_PASSWORD_SUCCESS') });
				})
				.catch(function (response) {
					const data = response.response.data;
					if (data.errors) {
						reject(data.errors);
					} else {
						reject();
					}
				});
    });
	}

	render () {
		return (
			<div className="container">
				<div className="columns">
					<div className="column"></div>
					<div className="column">
						<section className="section">
              <NavLink exact className="is-flex tovertaal-logo" style={{justifyContent: 'center' }} to="/">
                <img src={logo} alt="Tovertaal: Localisation System" width="140" height="55" />
              </NavLink>
						</section>
						<ResetPasswordForm onSubmit={this.resetPasswordSubmit} />
					</div>
					<div className="column"></div>
				</div>
			</div>
		);
	}
}

export default withApi(ForgotPassword);


// WEBPACK FOOTER //
// ./src/Pages/ForgotPassword.js